import React, { useEffect } from 'react';

import { sections } from './container';
import ReactGA from 'react-ga4';
import './App.scss';


const App = () => {
  useEffect(() => {
    ReactGA.initialize('G-1JJLMPGE82');
    // Send pageview with a custom path
    ReactGA.send({ hitType: "pageview", page: "/", title: "Landing Page" });
  }, []);
  
  return (
    <div className='app'>
      {
        sections.map((section) => <div id={section.id}>{section.component}</div>)
      }
    </div>
  );
};

export default App;
